import { render } from "./OrganisationEditor.vue?vue&type=template&id=600f698a&scoped=true"
import script from "./OrganisationEditor.vue?vue&type=script&lang=js"
export * from "./OrganisationEditor.vue?vue&type=script&lang=js"

import "./OrganisationEditor.vue?vue&type=style&index=0&id=600f698a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600f698a"]])

export default __exports__